import React, { Component, useState, useEffect } from "react";
import * as d3 from "d3";
import { DashboardStyles } from "../../styles";
import { RoadmapediaLogo } from "../../images";
import { useStitchAuth } from "../../StitchAuth.js";
import Navbar from "../Navbar.jsx";
import { app as mongoDB } from "../../stitch";
import { Link } from "react-router-dom";
import ReactTooltip from "../ReactTooltip.js";
import VerticalNavbar from "./VerticalNavbar.jsx";
import View from "./View.jsx";

const oneDummy = {
  title: "How to learn Web Dev in 2020",
  progress: "29",
  imageURL: "https://hatrabbits.com/wp-content/uploads/2017/01/random.jpg",
};

export default function Dashboard() {
  const { currentUser } = useStitchAuth();
  const [dashboardMode, setDashboardMode] = useState("roadmapView");
  const [RoadmapData, setRoadmapData] = useState({});
  const [roadmapLoading, setRoadmapLoading] = useState(true);
  useEffect(() => {
    mongoDB.currentUser.refreshCustomData().then(() => {
      const {
        createdRoadmaps: createdRoadmapIDs,
        starredRoadmaps: userStarredRoadmaps,
      } = currentUser.customData;

      console.log({ userStarredRoadmaps });

      const starredRoadmapIDs = userStarredRoadmaps.map((eachRoadmap) => {
        return eachRoadmap.roadmapId;
      });
      const query = {
        _id: { $in: [...starredRoadmapIDs, ...createdRoadmapIDs] },
      };

      // TODO: Initialize a MongoDB Service Client
      const mongoClient = currentUser.mongoClient("mongodb-atlas");

      // TODO: Instantiate a collection handle for todo.items
      const roadmapCollection = mongoClient.db("Main").collection("roadmaps");

      roadmapCollection.find(query).then((roadmaps) => {
        console.log("returned roadmaps", roadmaps);
        let newRoadmapsData = RoadmapData;
        let draftRoadmaps = [],
          createdRoadmaps = [],
          starredRoadmaps = [];

        roadmaps.map((eachRoadmap) => {
          const roadmapDataHistory = eachRoadmap.roadmapDataHistory;
          if (
            roadmapDataHistory[0].type === "Draft" &&
            roadmapDataHistory.length === 1
          ) {
            draftRoadmaps.push(eachRoadmap);
          } else if (
            roadmapDataHistory.length >= 1 &&
            roadmapDataHistory[0].type !== "Draft"
          ) {
            createdRoadmaps.push(eachRoadmap);
          }

          userStarredRoadmaps.map((rmap) => {
            if (rmap.roadmapId.$oid === eachRoadmap._id.toString()) {
              for (var i = 0; i < 10; i++) {
                var resourceNodeCount = rmap.resourceNodeCount.$numberInt;
                var completedNodeCount = rmap.completedNodesID.length;
                var editionIndex = rmap.editionIndex.$numberInt;
                starredRoadmaps.push({
                  ...eachRoadmap,
                  editionIndex: editionIndex,
                  percentage:
                    resourceNodeCount === 0
                      ? 0
                      : Math.floor(
                          (completedNodeCount / resourceNodeCount) * 100
                        ),
                });
              }
            }
          });
        });

        newRoadmapsData.created = createdRoadmaps;
        newRoadmapsData.drafted = draftRoadmaps;
        newRoadmapsData.starred = starredRoadmaps;
        console.log({ starredRoadmaps }, { createdRoadmaps });
        setRoadmapData(newRoadmapsData);
        setRoadmapLoading(false);
      });
      const query2 = {
        _id: { $in: starredRoadmapIDs },
      };
    });
  });

  return (
    <React.Fragment>
      <Navbar />

      <div className="DBContainer">
        <VerticalNavbar setDashboardMode={setDashboardMode} />
        <div className="DBRightContainer">
          <View
            roadmapLoading={roadmapLoading}
            RoadmapData={RoadmapData}
            dashboardMode={dashboardMode}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

/*
const message = currentUser
  ? "You have logged in as type: " +
    currentUser.loggedInProviderType +
    " with ID: " +
    currentUser.id
  : "You are logged out";
*/
